import { render, staticRenderFns } from "./StudentActivityDetailEdit.vue?vue&type=template&id=0c8cdad8"
import script from "./StudentActivityDetailEdit.vue?vue&type=script&lang=js"
export * from "./StudentActivityDetailEdit.vue?vue&type=script&lang=js"
import style0 from "./StudentActivityDetailEdit.vue?vue&type=style&index=0&id=0c8cdad8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports